import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetAllSOS } from "../../../../features/admin/sosrequest/slice";

export const IndexUse = () => {
  const dispatch = useDispatch();
  const country = useSelector((state) => state.customermanagement.customers);

  const [first_name, setName] = useState("");
  const [driverName, setDriverName] = useState("");
  const [bookingType, setBookingType] = useState("");
  const [email, setemail] = useState("");
  const [contact_no, setcontact_no] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");

  useEffect(() => {
    fetch();
  }, [first_name, email, contact_no, from, to, driverName, bookingType]);

  const fetch = async (page = country?.current_page) => {
    await dispatch(
      GetAllSOS({
        first_name: first_name,
        driverName,
        bookingType,
        email,
        contact_no,
        from,
        to,
        page: page,
        per_page: country?.per_page,
      })
    );
  };



  return {
    country,
    first_name,
    setName,
    email,
    setemail,
    contact_no,
    setcontact_no,
    from,
    setFrom,
    to,
    setTo,
    fetch,
    setDriverName,
    driverName,
    setBookingType,
    bookingType,
    // deleteData,
    // toggleStatus,
  };
};
